const firebaseConfig = {
  apiKey: "AIzaSyAP6_2d6mPGsVfzRkgMERf2Cbsub1VC8oI",
  authDomain: "cryptonic-8b570.firebaseapp.com",
  projectId: "cryptonic-8b570",
  storageBucket: "cryptonic-8b570.appspot.com",
  messagingSenderId: "349778246455",
  appId: "1:349778246455:web:35d001b99af8f785cd38b2"
};

export default firebaseConfig;
